import {AfterContentInit, AfterViewChecked, AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {UsuariosCargosService} from "./usuarios-cargos.service";
import {UsuariosCargosModel} from "./usuarios-cargos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {UsuariosCargosAcoesModel} from "./usuarios-cargos-acoes.model";
import {FormGroup} from "@angular/forms";

declare let swal: any;

@Component({
  selector: 'app-usuarios-cargos-privilegios',
  templateUrl: './usuarios-cargos-privilegios.component.html'
})
export class UsuariosCargosPrivilegiosComponent extends Components {


  @Input()
  privilegios_acoes = [];

  @Input()
  form: FormGroup;

  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  constructor(
    protected translate: TranslateService,
    protected router: Router,
    public global: Global,
    public func: Funcoes
  ) {
    super();

    // verifica se é uma página de edição
    if(router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos/usuarios-cargos-privilegios.component.ts